import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";

import {lang} from './index.js'

 const currentLang=localStorage.getItem("lang")!==undefined?localStorage.getItem("lang"):"en"

i18n.use(initReactI18next).init({
 resources: {lang }, 
 lng:currentLang||"en",   
});